<svg
  aria-labelledby="title description"
  class="w-full h-auto fill-inherit"
  width='100%'
  viewBox="0 0 32 32"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <title>Facebook logo</title>
  <path fill="currentColor" d="M23.3107 18L24.2159 12.2087H18.5566V8.45063C18.5566 6.86625 19.3471 5.32188 21.8817 5.32188H24.4545V0.39125C24.4545 0.39125 22.1198 0 19.8875 0C15.227 0 12.1806 2.77375 12.1806 7.795V12.2087H7V18H12.1806V32H18.5566V18H23.3107Z" />
</svg>
